import { control, progress, quadPath, quadPoint, INTRO_END, SPARK_PERIOD } from "@/components/knowledge/graphMotion";

const BASE = { branch: 0.6, cross: 0.16, project: 0.09 };
const WIDTH = { branch: 1.8, cross: 1.1, project: 1.2 };

const sparkEnvelope = (e, t, crossCount) => {
  if (e.kind !== "cross" || t < INTRO_END) return 0;
  const idx = Math.floor(t / SPARK_PERIOD) % crossCount;
  return idx === e.k ? Math.sin(Math.PI * ((t % SPARK_PERIOD) / SPARK_PERIOD)) : 0;
};

export const GraphEdges = ({ graph, pos, t, focus, tour }) => {
  const crossCount = graph.edges.filter((e) => e.kind === "cross").length;
  return (
    <g aria-hidden="true" fill="none" strokeLinecap="round">
      {graph.edges.map((e) => {
        const p0 = pos[e.a], p1 = pos[e.b];
        const c = control(p0, p1, e.curv);
        const prog = progress(t, e.start, e.dur);
        if (prog <= 0) return null;
        const spark = sparkEnvelope(e, t, crossCount);
        const on = focus?.edges.has(e.id);
        const lit = !focus && e.a === tour.id ? tour.env : 0;
        const opacity = focus ? (on ? 0.95 : 0.04) : BASE[e.kind] + spark * 0.6 + lit * 0.55;
        const width = WIDTH[e.kind] + (on ? 0.8 : 0) + spark * 1.4 + lit * 0.6;
        return (
          <path key={e.id} d={quadPath(p0, c, p1)} stroke={e.color} strokeWidth={width} strokeOpacity={opacity}
            pathLength="1" strokeDasharray="1 1" strokeDashoffset={1 - prog} style={{ transition: "stroke-opacity .3s" }} />
        );
      })}
    </g>
  );
};

// Small particles on a few selected paths: some branches, the theme currently lit by the tour, and the sparking cross-link
export const GraphParticles = ({ graph, pos, t, focus, tour }) => {
  const fadeIn = Math.min(1, Math.max(0, (t - INTRO_END + 1.5) / 2));
  if (!fadeIn) return null;
  const crossCount = graph.edges.filter((e) => e.kind === "cross").length;
  const travellers = graph.edges.filter((e) =>
    focus
      ? focus.edges.has(e.id) && e.kind !== "branch"
      : (e.kind === "branch" && e.phase < 1.2) || (e.a === tour.id && tour.env > 0.15) || sparkEnvelope(e, t, crossCount) > 0);
  return (
    <g aria-hidden="true">
      {travellers.map((e) => {
        const p0 = pos[e.a], p1 = pos[e.b];
        const c = control(p0, p1, e.curv);
        const s = (t * 0.11 + e.phase / 6.283) % 1;
        const along = e.kind === "project" ? 1 - s : s;
        const pt = quadPoint(p0, c, p1, along);
        return <circle key={e.id} cx={pt.x} cy={pt.y} r={2.8} fill={e.color} opacity={fadeIn * Math.sin(Math.PI * s) * 0.9} />;
      })}
    </g>
  );
};
